<template>
  <div class="page" ref="page">
    <div class="main">
      <div ref="main" class="pa-m">
        <div class="login">注册信息</div>
          <div class="ph-input">
            <van-field v-model="verifiedInfo.name" placeholder="姓名" clear-trigger="always" class="ph-t ph-t-icon" />
          </div>
          <div class="ph-input" style="margin-top:0px;" v-if="isBindPhone==3">
            <van-field v-model="verifiedInfo.idcard" placeholder="身份证号" clear-trigger="always" class="ph-t ph-t-icon" />
          </div>
          <div class="ph-input" style="margin-top:0px;">
            <van-field v-model="userPhone" type="tel" clear-trigger="always" class="ph-t ph-t-icon1" clearable
              placeholder="请输入本人手机号" />
          </div>
          <div class="ph-input" style="margin-top:0px;">
            <van-field v-model="smsCode" type="tel" clear-trigger="always" class="ph-t ph-t-icon2" clearable
              placeholder="验证码">
              <template #button>
                <van-button v-if="!countdown" size="small" type="primary" @click="getCode()">发送验证码</van-button>
                <van-button v-if="countdown" size="small" type="primary" disabled>{{ count }}S后重新获取</van-button>
              </template>
            </van-field>
          </div>



        <span style="text-align: center;" v-if="isBindPhone==3">
          <div class="title">请清晰拍出身份证信息，避免审核失败</div>
          <div class="many">
            <div class="uploadOuter">
              <input type="file" ref="file" @change="showImg($event, 'existFrontImg', 'frontImgUrl')">
              <div v-if="!existFrontImg">点击上传身份证正面</div>
              <img v-else :src="frontImgUrl" alt="">
            </div>
          </div>
        </span>


          <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">登录</van-button>
      </div>
      <div class="prompt" :style="{ 'margin-top': height + 'px' }">
        <div class="prompt-top">温馨提示</div>
        <div class="prompt-name">1、根据工信部规定，进入系统后要依法认证实名信息。</div>
        <div class="prompt-name">2、订购套餐+完成实名认证后，即可使用（首次订购套餐系统可能出现1小时左右延迟）</div>
      </div>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant'
export default {
  components: {
  },
  data() {
    return {
      isBindPhone: localStorage.getItem('isBindPhone'),
      existFrontImg: false,
      frontImgUrl: '',




      verifiedInfo: {
        iccid: localStorage.getItem('iccid'),
        name: '',
        userPhone: '',
        idcard: '',
        smsCode: '',
        isFirst: 0,
      },
      userPhone: null,
      smsCode: '',
      countdown: false,
      height: null,
      timer: null,
      count: null,
      isNewPage: localStorage.getItem('isNewPage'),
      iccid: localStorage.getItem('recordLoginText'),
    }
  },
  watch: {

  },
  mounted() {
    this.height = (this.$refs.page.clientHeight - this.$refs.main.clientHeight) / 2
  },
  methods: {
    showImg(event, showImgkey, imgUrl) {
      this.$data[showImgkey] = true;
      const files = event.target.files
      let filename = files[0].name          //只有一个文件
      if (filename.lastIndexOf('.') <= 0) {
        return alert("Please add a valid image!")        //判断图片是否有效
      }
      const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
      fileReader.addEventListener('load', () => {
        this.$data[imgUrl] = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    },



    getCode() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          const TIME_COUNT = 59
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countdown = false
            this.timer = setInterval(() => {
              if (this.count > 0) {
                this.count--
                this.countdown = true
              } else {
                this.countdown = false
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          Toast.success('发送成功')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    onSubmit() {
      this.verifiedInfo.userPhone=this.userPhone;
      this.verifiedInfo.smsCode=this.smsCode;
      if(this.isBindPhone!=3){
        this.verifiedInfo.idcard='无信息'
      }

      let fd = new FormData();
      Object.keys(this.verifiedInfo).forEach((key) => {
        fd.append(key, this.verifiedInfo[key]);
      })
      if(this.isBindPhone==3){
        if(this.$refs.file){
           fd.append('zCard', this.$refs.file.files[0]);
        }
      }


      wxRequest('bindPhone/phone/from', fd, 'post').then(res => {
        if (res.data.code === '200') {
          localStorage.setItem('userPhone', this.userPhone)
          if (this.isNewPage == 1) {
            this.$router.replace('/userNew/home');
          } else if (this.isNewPage == 2) {
            this.$router.replace('/user/homeNew');
          }else if (this.isNewPage == 3) {
            this.$router.replace('/new/home');
          } else {
            this.$router.replace('/user/home');
          }
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.page {
  background: #F7F8FA url('../../assets/userNew/icon4.png') no-repeat top center;
  background-size: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;

  .many {
    display: flex;
    justify-content: center;
    margin-bottom: 6px;
    label {
      display: block;
      line-height: 36px;
    }

    .uploadOuter {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48%;
      height: 100px;
      border: 1px dashed #e5e5e5;
      box-sizing: border-box;

      input[type=file] {
        position: absolute;
        top: 0;
        width: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .title {
    line-height: 28px;
    margin-top: 10px;
    color: red;
    font-weight: bold;
  }

  .btnOuter {
    display: flex;
    align-items: center;
    height: calc(100% - 424px)
  }

  .main {
    .pa-m{
      flex: 1;
      display: flex;
      align-items: stretch;
      flex-direction: column;
    }
    .login {
      margin: 60px 0px 0px 24px;
      font-size: 28px;
      color: rgb(6, 18, 30);
      font-weight: bold;
    }

    .login-text {
      color: #707070;
      font-size: 16px;
      margin-left: 24px;
      margin-top: 14px;
      line-height: 20px;
      width: 90%;
    }

    .captcha {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }

    .ph-input {
      margin: 40px 24px 20px;
      height: 60px;
      border-bottom: 1px solid #e3e2e2;
      flex-direction: row;
      align-items: center;
      flex-grow: 0;
      display: flex;

      .ph-text {
        color: #06121e;
        width: 50px;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
      }

      .ph-t {
        color: #06121e;
        flex: 1;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
        padding: 0;
        background: none;

        ::v-deep .van-field__left-icon {
          .van-icon {
            font-size: 22px;
          }
        }

        ::v-deep.van-cell__value {
          .van-field__control {
            background: none;
            padding-left: 14px;
            color: #000;
            line-height: 50px;
            height: 50px;
          }
        }
      }

      .ph-t-icon {
        background: url('../../assets/userNew/icon7.png') no-repeat left center;
        background-size: 23px 18px;
        padding-left: 20px;
      }

      .ph-t-icon1 {
        background: url('../../assets/userNew/icon5.png') no-repeat left center;
        background-size: 15px 22px;
        padding-left: 20px;
      }

      .ph-t-icon2 {
        background: url('../../assets/userNew/icon6.png') no-repeat left center;
        background-size: 19px 22px;
        padding-left: 20px;
      }
    }

    .bu_tn {
      width: 230px;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #3476fe;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }

    .bu_tn-a {
      width: 80%;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #fff;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }
  }

  .prompt {
    padding: 18px;
    width: 80%;
    background: #fff;
    border-radius: 10px;
    margin: auto;

    .prompt-top {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-left: 22px;
      background: url('../../assets/userNew/icon2.png') no-repeat left center;
      background-size: 17px 12px;
    }

    .prompt-name {
      color: #646668;
      font-size: 12px;
      line-height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>
  
  